import { jsx as _jsx } from "react/jsx-runtime";
// Google product sprite sheet (2x). Confirmed positions for background-size: 55px.
// Gmail confirmed: width 50, height 50, bg-size 55px, position 0 -545px.
// Others scaled proportionally (545/522 ratio from Gmail anchor).
const SPRITE_POSITIONS = {
    gmail: -545,
    drive: -2110,
    calendar: -1385,
    contacts: -485,
};
function SpriteIcon({ service, size }) {
    return (_jsx("span", { style: {
            display: "inline-block",
            width: size,
            height: size,
            backgroundImage: `url(/google-sprite.png)`,
            backgroundSize: "55px auto",
            backgroundPosition: `0px ${SPRITE_POSITIONS[service]}px`,
            backgroundRepeat: "no-repeat",
        } }));
}
export function GmailIcon({ size = 50 }) {
    return _jsx(SpriteIcon, { service: "gmail", size: size });
}
export function DriveIcon({ size = 50 }) {
    return _jsx(SpriteIcon, { service: "drive", size: size });
}
export function CalendarIcon({ size = 50 }) {
    return _jsx(SpriteIcon, { service: "calendar", size: size });
}
export function ContactsIcon({ size = 50 }) {
    return _jsx(SpriteIcon, { service: "contacts", size: size });
}
